package com.karyadina.service

import com.karyadina.model.Flashcard
import com.karyadina.model.Unit

/**
 * JS/Web stub for flashcard PDF export
 */
actual suspend fun exportFlashcardsToPdf(
    cards: List<Flashcard>,
    units: List<Unit>,
    title: String,
    includeQuestions: Boolean,
    includeAnswers: Boolean,
    includeHints: Boolean,
    onlyImages: Boolean
): String? {
    // Web PDF export not implemented
    return null
}
